import React, {Component, FormEvent} from 'react'
import { withRouter } from 'react-router-dom'
import Form from './Form';
import Logs from './Logs';
import {flow} from "lodash";
import BackOfficeAPIClient from "../../../clients/BackofficeAPIClient";

class Index extends Component {

  constructor(props) {
    super(props);
    this.backofficeApiClient = new BackOfficeAPIClient()

    this.state = {
      ongletActif: 'Configuration',
      flowDirection: '',
      savedFlowDirection: '',
      saving: false,
    }
  }

  setOngletActif(onglet){
    this.setState({
      ongletActif: onglet
    })
  }

  componentWillMount() {
    this.fetchFlowDirection();
  }

  async fetchFlowDirection(){
    await this.backofficeApiClient.get("/group-settings/pvo2_flow_direction")
        .then((response) => {
          this.setState({flowDirection: response.value, savedFlowDirection: response.value});
        })
        .catch((error) => {
          console.log(error);
        });
  }

  onChangeFlowDirection(e) {
    const { value } = e.target;
    this.setState({flowDirection: value});
  }

  async handleSubmit(event) {
    event.preventDefault();

    this.setState({ saving: true });

    await this.backofficeApiClient.put("/group-settings/pvo2_flow_direction", { value: this.state.flowDirection })
        .then(() => {
          this.setState({ savedFlowDirection: this.state.flowDirection, saving: false });
        })
        .catch((error) => {
          console.log(error);
          this.setState({ saving: false });
        });
  }

  render() {

    return (
        <div className='container-fluid'>
          <div className='row'>
            <div className='col'>
              <h2>Interface PVO2</h2>

              <br />

              <ul className="nav nav-tabs" id="myTab">
                <li className="nav-item">
                  <a className="nav-link active" id="configuration-tab" data-toggle="tab" href="#configuration" role="tab" aria-controls="configuration" aria-selected="true" onClick={() => this.setOngletActif('Configuration')}>Configuration</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" id="logs-tab" data-toggle="tab" href="#logs" role="tab" aria-controls="logs" aria-selected="true" onClick={() => this.setOngletActif('Logs')}>Logs</a>
                </li>
              </ul>

              <div className="tab-content" id="myTabContent" style={{ paddingTop: '15px' }}>
                <div className="d-flex ml-3 mb-3 align-items-end">
                  <div className="mr-3">
                    <small className="form-text text-muted">
                      Sens du flux de données entre EDV et PVO2
                    </small>
                    <select
                        value={this.state.flowDirection}
                        onChange={(e) => this.onChangeFlowDirection(e)}
                        id='pvo2_flow_direction'
                        name="pvo2_flow_direction"
                        className="form-control form-control-sm">
                      {this.state.flowDirection === '' && <option value=""></option>}
                      <option value={'edv_to_pvo2'}>EDV vers PVO2</option>
                      <option value={'pvo2_to_edv'}>PVO2 vers EDV</option>
                    </select>
                  </div>
                  {this.state.flowDirection !== this.state.savedFlowDirection ?
                    <button
                        type="submit"
                        className="btn btn-primary btn-sm"
                        disabled={this.state.saving}
                        onClick={this.handleSubmit.bind(this)}
                    >
                      {this.state.saving ?
                        <span><i className='fa fa-spinner fa-spin fa-fw'></i>&nbsp;</span>
                      : null}
                      Enregistrer
                    </button>
                  : null}
                </div>
                <div className="tab-pane fade show active" id="configuration" role="tabpanel" aria-labelledby="configuration-tab">
                  <Form />
                </div>
                <div className="tab-pane fade" id="logs" role="tabpanel" aria-labelledby="logs-tab">
                  {/* Pour éviter de charger les logs alors qu'on veut juste voir la config */
                    this.state.ongletActif === "Logs" ?
                        <Logs />
                        :
                        null
                  }
                </div>
              </div>

            </div>
          </div>
        </div>
    );
  }
}

export default withRouter(Index);
